import './_search-drawer-top-searches.scss';

export default () => {};
